import {BREADCRUMB_ORBIT_CLUSTER_PATH} from "./types";

export const setBreadcrumbOrbitClusterPath = (value) => ({
    type: BREADCRUMB_ORBIT_CLUSTER_PATH,
    payload: {
        orbitClusterPath: value.orbitClusterPath,
        name: value.name
    }
})
